export default {
    shopifyDomain: "performa-artist-editions.myshopify.com",
    shopifyToken: "347b007757aaf61240ed591df324c6f9",
    collectionHandle: 232664531132
}